// AI-assisted: Claude 2026-08-07, human-reviewed: ausstehend
// Satz-Pause: startet sofort beim Einhängen, zeitstempel-basiert (korrekt nach
// Handy-Sperre). Kleiner Bruder des IntervalTimer — bewusst minimal, kein Pausieren.
import { useEffect, useRef, useState } from "react"
import { playBeep, vibrate } from "@/lib/timer"

export default function RestTimer({ seconds, onDone, onSkip }: {
  seconds: number
  onDone: () => void
  onSkip: () => void
}) {
  const startRef = useRef(Date.now())
  const [remaining, setRemaining] = useState(seconds)
  const doneRef = useRef(onDone)
  doneRef.current = onDone

  useEffect(() => {
    // gleicher Ton-Schalter wie der IntervalTimer
    const sound = localStorage.getItem("fithub:timer-sound") !== "aus"
    let lastCue = Infinity // letzte Restsekunde mit Signal — verhindert Doppel-Piepen
    const id = setInterval(() => {
      const rem = Math.ceil(seconds - (Date.now() - startRef.current) / 1000)
      setRemaining(Math.max(0, rem))
      if (rem !== lastCue) {
        lastCue = rem
        if (rem <= 0) {
          if (sound) playBeep(240, 990)
          vibrate(90)
          clearInterval(id)
          doneRef.current()
        } else if (rem <= 3) {
          if (sound) playBeep(110, 880)
          vibrate(50)
        }
      }
    }, 250)
    return () => clearInterval(id)
  }, [seconds])

  return (
    <div className={`rtimer enter${remaining <= 3 ? " countdown" : ""}`} role="timer">
      <span className="rtimer-label">Pause</span>
      <div className="rtimer-time num-hero" aria-live={remaining <= 3 ? "assertive" : "off"}>
        {remaining}
      </div>
      <button type="button" className="btn-secondary rtimer-skip" onClick={onSkip}>
        Pause überspringen
      </button>
    </div>
  )
}
